export default "__VITE_ASSET__ef4f0a3d__"